import { styled } from '@mui/material';
import { Icon_AddCircle, Icon_EdgeFoldPaper, Icon_Flag, Icon_StarShield } from '../common/CommonIcons';
import { parseDateToKorean } from 'src/utils/DateUtils';

interface Props{
    sessionData : any;
    now : string
}

interface SessionWrapperProps {
    now: string;
  }

const SessionWrapper = styled('div')<SessionWrapperProps>(({ now })=>({
  position:'relative',
    display: 'flex',
    minHeight:'44px',
    width:'100%',
    color:(now === '입영일' || now === '임관일') ? '#0B4D3C' : 'white',
    fontWeight:600,
    fontSize:'12px',
    borderRadius:'4px',
    backgroundColor:
    now === '추가과정'
      ? '#117E61' // 추가접수 배경
      : now === '입영일'
      ? '#49CDAA' // 입영일 배경
      : now === '임관일'
      ? '#A4E6D5' // 임관일 배경
      : now === '접수'
      ? '#0B4D3C' // 접수 배경
      : '#FFFFFF', // 기본 배경
}))

const mapImg = (now:string)=>{
    switch (now) {
        case '추가과정':
          return <Icon_AddCircle style={{scale:0.7}}/>
        case '입영일':
          return <Icon_Flag/>
        case '임관일':
          return <Icon_StarShield/>
        case '접수':
          return <Icon_EdgeFoldPaper/>
        default:
          return '';
      }
}

const NowWrapper = styled('div')({
    borderRight: '1px solid white',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    gap:'8px',
    margin:'8px 0px 8px 24px',
    paddingRight:'16px',
    minWidth:'91px',
    maxWidth:'91px'
})

const DateWrapper = styled('div')({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    margin:'auto'
})

const DateContainter = styled('div')({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    gap:'8px'
})

const DateBox = styled('div')({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  flexDirection:'column'
})

const PageContainer = styled('div')({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    width:'100%',
    gap:'18px'
})

const PageWrapper = styled('div')({
    display:'flex',
    flexDirection:'column',
    gap:'8px',
    marginTop:'12px'
})

const CircleWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  });

interface CircleProps{
    isNow? : boolean
}

const Circle = styled('div')<CircleProps>(({ isNow }) => ({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',

  width: '8px',
  height: '8px',
  borderRadius: '50%',
  ...(isNow
    ? {
        backgroundColor: '#FFF',
        border: '0.5px solid #31F2BD',
        filter: 'drop-shadow(0px 0px 4px rgba(49, 242, 189, 0.8))',
      }
    : {
        backgroundColor: '#189187',
      }),
  }));
  
  const Line = styled('div')({
    position:'absolute',
    height: 'calc(100% + 8px)',
    backgroundColor: 'black',
    flexGrow: 1,
    marginTop: '4px', // 바로 이어붙이기
    border:'1px solid #ACACAC',
    top: 'calc(50% - ((100% - 44px)/2))',
    left:'-23px',
    zIndex:-1
  });

const RecruitSession = ({sessionData, now}:Props) => {


  return (
    <PageWrapper>
        {sessionData?.map((content:any,index:any)=>{
          const fullDateStart = parseDateToKorean(content.start_date);
          const fullDateEnd = parseDateToKorean(content.end_date);
          const [styear, stmonth, stday] = fullDateStart.split(' ');
          const [edyear, edmonth, edday] = fullDateEnd.split(' ');
          const stmonth_day = `${stmonth} ${stday}`
          const edmonth_day = `${edmonth} ${edday}`
          return(
            <PageContainer>
            <CircleWrapper>
            <Circle isNow={content.course_name === now}>
              {content.now === now &&
              <Circle style={{width:'6px', height:'6px', backgroundColor:'#31F2BD'}}/>
              }
            </Circle>
            
            </CircleWrapper>
            <SessionWrapper now={['입영일', '임관일'].includes(content.course_name) ? content.course_name : content.course_name === '접수일정' ? "접수": '추가과정'}>
                {index !== sessionData.length - 1 && <Line />} {/* 마지막에는 Line 안나오게 */}
                <NowWrapper>
                    {mapImg(['입영일', '임관일'].includes(content.course_name) ? content.course_name : '추가과정')}
                    <div style={{minWidth:'45px'}}>
                    {content.course_name === '접수일정' ? "접수": content.course_name}
                    </div>
                </NowWrapper>
                <DateWrapper>
                    {content.start_date !== content.end_date ? 
                    <DateContainter>
                        <DateBox>
                          <div>
                            {styear === edyear ? '':styear}
                          </div>
                          <div>
                            {stmonth_day}
                            </div>
                        </DateBox>
                        <div>-</div>
                        <DateBox>
                          <div>
                            {styear === edyear ? '':edyear}
                          </div>
                          <div>
                            {edmonth_day}
                            </div>
                        </DateBox>
                    </DateContainter>:
                    <>
                      {edmonth_day}
                    </>}

                </DateWrapper>
            </SessionWrapper>
            </PageContainer>
        )})}
    </PageWrapper>
  )
}

export default RecruitSession